export const faqData = [
  {
    question:"Tellus quisque proin dolor purus?",
    answer:"Commodo auctor facilisis mauris ad lectus id risus suscipit. Litora ac consequat ridiculus dignissim mi netus eu at. Eleifend consectetuer hendrerit euismod volutpat a semper ante ridiculus."
  },
  {
    question:"Commodo auctor facilisis mauris?",
    answer:"Commodo auctor facilisis mauris ad lectus id risus suscipit. Litora ac consequat ridiculus dignissim mi netus eu at. Eleifend consectetuer hendrerit euismod volutpat a semper ante ridiculus."
  },
  {
    question:"Ignissim mi netus eu at. Eleifend consectetuer hendrer?",
    answer:"Commodo auctor facilisis mauris ad lectus id risus suscipit. Litora ac consequat ridiculus dignissim mi netus eu at. Eleifend consectetuer hendrerit euismod volutpat a semper ante ridiculus."
  },
  {
    question:"Euismod volutpat a semper ante ridiculus.?",
    answer:"Commodo auctor facilisis mauris ad lectus id risus suscipit. Litora ac consequat ridiculus dignissim mi netus eu at. Eleifend consectetuer hendrerit euismod volutpat a semper ante ridiculus."
  },
  {
    question:"Mauris ad lectus id risus nsequat ridiculus dignissim mi?",
    answer:"Commodo auctor facilisis mauris ad lectus id risus suscipit. Litora ac consequat ridiculus dignissim mi netus eu at. Eleifend consectetuer hendrerit euismod volutpat a semper ante ridiculus."
  },
  {
    question:"Tridiculus dignissim mi netus eu at?",
    answer:"Commodo auctor facilisis mauris ad lectus id risus suscipit. Litora ac consequat ridiculus dignissim mi netus eu at. Eleifend consectetuer hendrerit euismod volutpat a semper ante ridiculus."
  },
  {
    question:"Quisque proin dolor purus?",
    answer:"Commodo auctor facilisis mauris ad lectus id risus suscipit. Litora ac consequat ridiculus dignissim mi netus eu at. Eleifend consectetuer hendrerit euismod volutpat a semper ante ridiculus."
  },
  {
    question:"Ellus quisque proin dolor purus?",
    answer:"Commodo auctor facilisis mauris ad lectus id risus suscipit. Litora ac consequat ridiculus dignissim mi netus eu at. Eleifend consectetuer hendrerit euismod volutpat a semper ante ridiculus."
  },
  {
    question:"Des quisque proin dolor purus?",
    answer:"Commodo auctor facilisis mauris ad lectus id risus suscipit. Litora ac consequat ridiculus dignissim mi netus eu at. Eleifend consectetuer hendrerit euismod volutpat a semper ante ridiculus."
  },
]